import { useEffect, useState } from "preact/hooks";
import { Brand } from "../../components/Brand/Brand";
import { Categories } from "../../components/Categories/Categories";
import { CouponSelection } from "../../components/Coupons/CouponSelection/CouponSelection";
import "./style.css";
import { fetchFeed } from "../../services/coupon.service";
import SearchBarComponent from "../../components/SearchBarComponent";

// `category` = 2-digit code for getCategories.php (the feed API only accepts
//   2-digit parent codes or 6-digit subcategory codes, NOT 6-digit padded parents).
// `categoryId` = 6-digit code for the /category/{id} link (getByCategory.php
//   accepts both formats).
const HOME_SECTIONS = [
  { title: "Restaurants",     category: "12", categoryId: "120000" },
  { title: "Automobile",      category: "02", categoryId: "020000" },
  { title: "Home & Family",   category: "09", categoryId: "090000" },
  { title: "Health & Beauty", category: "08", categoryId: "080000" },
];

const Home = () => {
  useEffect(() => {
    document.title = "EZ Coupons — Local Coupons in Utah County";
  }, []);

  const [couponSelections, setCouponSelections] = useState<any>(
    HOME_SECTIONS.map(s => ({ ...s, coupons: [] }))
  );

  useEffect(() => {
    HOME_SECTIONS.forEach((section, index) => {
      fetchFeed("UT", "25", section.category)
        .then(res => {
          if (!res?.data) return;
          const rows = Array.isArray(res.data[0])
            ? [...res.data[0], ...(res.data[1] || [])]
            : res.data;
          setCouponSelections(prev => {
            const next = [...prev];
            next[index] = { ...next[index], coupons: rows };
            return next;
          });
        })
        .catch(() => {});
    });
  }, []);

  return (
    <div class="home">
      <SearchBarComponent />
      <Categories />
      {couponSelections[0].coupons?.length ? (
        <Brand
          dailyDeals={couponSelections
            .filter(sel => sel.coupons?.length)
            .map(sel => sel.coupons[0])}
        />
      ) : null}
      <section class="coupon-selection-section">
        {couponSelections.map(cat => (
          <CouponSelection
            coupons={cat.coupons}
            selectionTitle={cat.title}
            categoryId={cat.categoryId}
          />
        ))}
      </section>
    </div>
  );
};

export default Home;
